import { useContext } from "react";
import { RegisterContext } from "../../contexts/registerContext";

export default function useRegister() {
  const value = useContext(RegisterContext);

  return value;
}
